import axios from "axios";
import React, { useEffect, useState } from "react";
import ImageLoading from "../../../components/ImageLoading";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { FiFilter } from "react-icons/fi";

const OdActionTable = ({ checkPledged }) => {
  const [loading, setLoading] = useState(false);
  const [topPledgedMutualFunds, setTopPledgedMutualFunds] = useState({});

  const [hasPledgedFund, setHasPledgedFund] = useState(true);

  const [openAdvancedFilter, setOpenAdvancedFilter] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [advancedEndDate, setAdvancedEndDate] = useState("");
  const [reRender, setReRender] = useState(false);
  const [selectedFlag, setSelectedFlag] = useState({
    value: "overall",
    label: "Overall",
  });
  const [advancedOptionSelected, setAdvancedOptionSelected] =
    useState("overall");

  const getTopPledgedMutualFunds = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/dashboards/activity?view_type=${advancedOptionSelected}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res.data) {
        setTopPledgedMutualFunds(res?.data?.od_activity);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTopPledgedMutualFunds();
  }, [reRender]);

  checkPledged(hasPledgedFund);

  function formatText(input) {
    if (input === null || input === undefined) return "---";
    return input
      .split("_") // Split the string by underscores
      .map(
        (
          word // Iterate over each word
        ) =>
          word.charAt(0).toUpperCase() + // Capitalize the first letter
          word.slice(1).toLowerCase() // Convert the rest of the word to lowercase
      )
      .join(" "); // Join the words with a space
  }

  const options = [
    { value: "overall", label: "Overall" },
    { value: "today", label: "Today" },
    { value: "last_seven_days", label: "Last 7 days" },
    { value: "last_thirty_days", label: "Last 30 days" },
    { value: "last_six_months", label: "Last 6 months" },
    { value: "last_one_year", label: "Last 1 Year" },
  ];
  const clearFilters = () => {
    setAdvancedOptionSelected("");
    setSelectedFlag("");
    setFilterApplied(false);
  };

  return (
    <>
      {loading ? (
        <div className="flex w-full h-[30vh] justify-center items-center ">
          <ImageLoading />
        </div>
      ) : (
        <>
          {" "}
          <div className="bg-white h-full rounded-lg relative">
            <div className="flex flex-row justify-between items-center mx-4">
              <p className="text-[16px] font-semibold mt-[17px] mb-[14px]">
                OD Activity
              </p>
              <div
                className={`rounded p-1 cursor-pointer text-white flex items-center justify-center w-8 h-8 ${
                  filterApplied
                    ? "bg-[#00394D]"
                    : "border-[#DADADA] border border-solid"
                }`}
                onClick={() => setOpenAdvancedFilter(!openAdvancedFilter)}
              >
                <FiFilter
                  size={"17px"}
                  color={filterApplied ? "#ffffff" : "#656565"}
                />{" "}
              </div>
            </div>
            {openAdvancedFilter && (
              <div className=" w-[190px] px-2 rounded-b-lg absolute top-12 right-0 z-10 bg-white pt-[12px] text-xs font-medium shadow-md pb-2 ">
                <p className="text-sm font-bold text-[#262626] mb-2">
                  Filter by date
                </p>
                <Select
                  options={options}
                  value={selectedFlag}
                  onChange={(e) => {
                    setSelectedFlag(e);
                    setAdvancedOptionSelected(e?.value);
                  }}
                />

                <div className="flex w-full justify-between items-center ">
                  <button
                    type="button"
                    className={` py-[3px] px-2 rounded w-[46%] h-8 font-medium bg-[#00394d] text-white mt-3`}
                    onClick={() => {
                      if (advancedOptionSelected !== null) {
                        setReRender(!reRender);
                        setOpenAdvancedFilter(false);
                        // fetchAdvancedFilters();
                      }
                    }}
                  >
                    Filter
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      // clearAdvancedFilters();
                      clearFilters();

                      setReRender(!reRender);
                      setOpenAdvancedFilter(false);
                    }}
                    className="py-[3px] px-2 rounded w-[46%] h-8 font-medium  text-[#00394d] border border-[#00394d] mt-3"
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}

            <table className="w-full">
              <thead className=" bg-[#e6ebed] text-sm">
                <th className=" h-[36px] w-[65%] text-left pl-[50px]">
                  Activity
                </th>
                <th> Value</th>
              </thead>
              <tbody className=" text-center text-xs font-medium">
                {topPledgedMutualFunds &&
                  Object.keys(topPledgedMutualFunds)?.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        className={` ${
                          index % 2 === 0 ? "bg-[#ffffff]" : "bg-[#f8f8f8]"
                        }`}
                      >
                        <td className=" h-[36px] text-left pl-[50px]">
                          {formatText(item) || "---"}
                        </td>
                        <td>{topPledgedMutualFunds[item] || "---"}</td>
                      </tr>
                    );
                  })}
                <td></td>
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default OdActionTable;
